import Vue from "vue"

import VueRouter, { RouteConfig } from "vue-router"
import PasswortVergessen from "@/components/PasswortVergessen.vue"
import PasswortAendernUser from "@/components/PasswortAendern.vue"
import Registrieren from "@/components/bestellung/Registrieren.vue"
import AbholungStarten from "@/components/bestellung-neu/AbholungStarten.vue"
import AbholungStartenTisch from "@/components/bestellung-neu/AbholungStartenTisch.vue"
import TerminAbholung from "@/components/bestellung-neu/TerminAbholung.vue"
import TerminReservierungNeu from "@/components/bestellung-neu/TerminReservierungNeu.vue"
import TerminSofort from "@/components/bestellung-neu/TerminSofort.vue"
import TerminLieferung from "@/components/bestellung-neu/TerminLieferung.vue"
import TerminQrCode from "@/components/bestellung-neu/TerminQrCode.vue"
import Verzehrart from "@/components/bestellung-neu/Verzehrart.vue"
import SofortSelect from "@/components/bestellung-neu/SofortSelect.vue"
import Shopping from "@/components/bestellung-neu/Shopping.vue"
import ShoppingProdukte from "@/components/bestellung-neu/ShoppingProdukte.vue"
import ShoppingArtikel from "@/components/bestellung-neu/ShoppingArtikel.vue"
import ShoppingLieferung from "@/components/bestellung-neu/ShoppingLieferung.vue"
import ShoppingProdukteLieferung from "@/components/bestellung-neu/ShoppingProdukteLieferung.vue"
import ShoppingLieferungArtikel from "@/components/bestellung-neu/ShoppingLieferungArtikel.vue"
import Warenkorb from "@/components/bestellung-neu/Warenkorb.vue"
import WarenkorbLieferung from "@/components/bestellung-neu/WarenkorbLieferung.vue"
import Kundendaten from "@/components/bestellung-neu/Kundendaten.vue"
import KundendatenReservierung from "@/components/bestellung-neu/KundendatenReservierung.vue"
import KundendatenLieferung from "@/components/bestellung-neu/KundendatenLieferung.vue"
import Bestaetigen from "@/components/bestellung-neu/Bestaetigen.vue"
import BestaetigenLieferung from "@/components/bestellung-neu/BestaetigenLieferung.vue"
import BestaetigenAbholung2 from "@/components/bestellung-neu/BestaetigenAbholung2.vue"
import BestaetigenReservierungNeu from "@/components/bestellung-neu/BestaetigenReservierungNeu.vue"
import ReservierungBestaetigt from "@/components/bestellung-neu/ReservierungBestaetigt.vue"
import Bestaetigt from "@/components/bestellung-neu/Bestaetigt.vue"
import BezahlungWeiterleiten from "@/components/bestellung-neu/BezahlungWeiterleiten.vue"
import BezahlungBestaetigen from "@/components/bestellung-neu/BezahlungBestaetigen.vue"
import Bestellungen from "@/components/Bestellungen.vue"
import AbgeschlosseneBestellungen from "@/components/AbgeschlosseneBestellungen.vue"
import Bestellung from "@/components/bestellung/Bestellung.vue"
import Details from "@/components/bestellung/Details.vue"
import ReservierungDetails from "@/components/bestellung/ReservierungDetails.vue"
import Bezahlen from "@/components/bestellung/Bezahlen.vue"
import BezahlenBestaetigt from "@/components/bestellung/BezahlenBestaetigt.vue"
import FilialeInfo from "@/components/bestellung/FilialeInfo.vue"
import BezahlenWeiterleitenBestellung from "@/components/bestellung/BezahlungWeiterleitenBestellung.vue"
import AgbFiliale from "@/components/rechtliches/AgbFiliale.vue"
import DatenschutzFiliale from "@/components/rechtliches/DatenschutzFiliale.vue"
import ImpressumFiliale from "@/components/rechtliches/ImpressumFiliale.vue"

import PasswortAendernKunde from "@/components/bestellung/PasswortAendern.vue"
import ServiceAnfordern from "@/components/bestellung/ServiceAnfordern.vue"
import ReservierungSelectVorbestellung from "@/components/bestellung-neu/ReservierungSelectVorbestellung.vue"
import Nachbestellung from "@/components/bestellung/Nachbestellung.vue"
import NachbestellungArtikel from "@/components/bestellung/NachbestellungArtikelEdit.vue"
import NachbestellungProdukte from "@/components/bestellung/NachbestellungProdukte.vue"
import NachbestellungBestaetigen from "@/components/bestellung/NachbestellungBestaetigen.vue"
import ReservierungBestellung from "@/components/bestellung/ReservierungBestellung.vue"
import ReservierungBestellungArtikel from "@/components/bestellung/ReservierungBestellungArtikel.vue"
import ReservierungBestellungBestaetigen from "@/components/bestellung/ReservierungBestellungBestaetigen.vue"
import ReservierungBestellungProdukte from "@/components/bestellung/ReservierungBestellungProdukte.vue"
import ReservierungVorbestellung from "@/components/bestellung/ReservierungVorbestellung.vue"
import ReservierungVorbestellungProdukte from "@/components/bestellung/ReservierungVorbestellungProdukte.vue"
import ReservierungVorbestellungArtikel from "@/components/bestellung/ReservierungVorbestellungArtikel.vue"
import ReservierungVorbestellungBestaetigen from "@/components/bestellung/ReservierungVorbestellungBestaetigen.vue"
import ReservierungVorbestellungBearbeiten from "@/components/bestellung/ReservierungVorbestellungBearbeiten.vue"
import TrinkgeldBestellung from "@/components/bestellung/TrinkgeldBestellung.vue"

import ReservierungVorbestellungNeu from "@/components/bestellung-neu/ReservierungVorbestellung.vue"
import ReservierungVorbestellungProdukteNeu from "@/components/bestellung-neu/ReservierungVorbestellungProdukte.vue"
import ReservierungVorbestellungArtikelNeu from "@/components/bestellung-neu/ReservierungVorbestellungArtikel.vue"
import ReservierungVorbestellungBestaetigenNeu from "@/components/bestellung-neu/ReservierungVorbestellungBestaetigen.vue"
import RouteNames from "@/util/route_names"
import UserPage from "@/components/UserPage.vue"
import FilialeMain from "@/components/bestellung-neu/FilialeMain.vue"
import StandortLieferung from "@/components/bestellung-neu/StandortLieferung.vue"
import StandortLieferungPlz from "@/components/bestellung-neu/StandortLieferungPlz.vue"
import Trinkgeld from "@/components/bestellung/Trinkgeld.vue"
import TischbestellungStarten from "@/components/bestellung-neu/TischbestellungStarten.vue"
import { component } from "vue/types/umd"
import Reservierung from "@/components/bestellung/Reservierung.vue"

Vue.use(VueRouter)

const routes: RouteConfig[] = [
  {
    path: "",
    component: UserPage,
    children: [
      {
        path: "",
        name: RouteNames.NEU.HOME,
        component: FilialeMain,
      },
      {
        path: "info",
        name: RouteNames.NEU.INFO_PAGE,
        component: FilialeInfo,
      },
      {
        path: "filiale-info/:filialeId",
        name: RouteNames.BESTELLUNG.FILIALE_INFO,
        component: FilialeInfo,
      },
      {
        path: "passwort-aendern",
        name: RouteNames.BESTELLUNG.PASSWORT_AENDERN,
        component: PasswortAendernKunde,
      },
      {
        path: "registrieren",
        name: RouteNames.REGISTRIEREN,
        component: Registrieren,
      },
      {
        path: "passwort-vergessen",
        name: RouteNames.PASSWORT_VERGESSEN,
        component: PasswortVergessen,
      },
      {
        path: "passwort-erneuern/:id",
        name: RouteNames.PASSWORT_AENDERN,
        component: PasswortAendernUser,
      },
      { path: "abholung-starten", component: AbholungStarten },
      { path: "abholung-starten-tisch/:id", component: AbholungStartenTisch },
      {
        path: "tischbestellung-starten/:id",
        component: TischbestellungStarten,
      },
      {
        path: "tisch-qr-buchen/:id",
        name: RouteNames.NEU.TISCH_QR_BUCHEN,
        component: TerminQrCode,
      },
      {
        path: "termin-abholung",
        name: RouteNames.NEU.TERMIN_ABHOLUNG,
        component: TerminAbholung,
      },
      {
        path: "termin-reservierung",
        name: RouteNames.NEU.TERMIN_RESERVIERUNG,
        component: TerminReservierungNeu,
      },
      {
        path: "termin-lieferung",
        name: RouteNames.NEU.TERMIN_LIEFERUNG,
        component: TerminLieferung,
      },
      {
        path: "standort-lieferung",
        name: RouteNames.NEU.STANDORT_LIEFERUNG,
        component: StandortLieferung,
      },
      {
        path: "standort-lieferung-plz",
        name: RouteNames.NEU.STANDORT_LIEFERUNG_PLZ,
        component: StandortLieferungPlz
      },
      {
        path: "verzehrart",
        name: RouteNames.NEU.VERZEHRART,
        component: Verzehrart,
      },
      {
        path: "sofortbestellung-tisch",
        name: RouteNames.NEU.SOFORTBESTELLUNG_TISCH,
        component: TerminSofort,
      },
      {
        path: "sofortbestellung-bestellart",
        name: RouteNames.NEU.SOFORTBESTELLUNG_BESTELLART,
        component: SofortSelect,
      },
      {
        path: "shopping-lieferung",
        component: ShoppingLieferung,
        children: [
          {
            path: "",
            component: ShoppingProdukteLieferung,
            name: RouteNames.NEU.SHOPPING_LIEFERUNG.PRODUKTE,
          },
          {
            path: "artikel/:id",
            component: ShoppingLieferungArtikel,
            name: RouteNames.NEU.SHOPPING_LIEFERUNG.ARTIKEL,
          },
        ],
      },
      {
        path: "shopping",
        component: Shopping,
        children: [
          {
            path: "",
            component: ShoppingProdukte,
            name: RouteNames.NEU.SHOPPING.PRODUKTE,
          },
          {
            path: "artikel/:id",
            name: RouteNames.NEU.SHOPPING.ARTIKEL,
            component: ShoppingArtikel,
          },
        ],
      },
      {
        path: "warenkorb",
        name: RouteNames.NEU.WARENKORB,
        component: Warenkorb,
      },
      {
        path: "warenkorb-lieferung",
        name: RouteNames.NEU.WARENKORB_LIEFERUNG,
        component: WarenkorbLieferung,
      },
      {
        path: "kundendaten",
        name: RouteNames.NEU.KUNDENDATEN,
        component: Kundendaten,
      },
      {
        path: "kundendaten-reservierung",
        name: RouteNames.NEU.KUNDENDATEN_RESERVIERUNG,
        component: KundendatenReservierung,
      },
      {
        path: "kundendaten-lieferung",
        name: RouteNames.NEU.KUNDENDATEN_LIEFERUNG,
        component: KundendatenLieferung,
      },
      {
        path: "reservierung-select-vorbestellung",
        name: RouteNames.NEU.RESERVIERUNG_SELECT_VORBESTELLUNG,
        component: ReservierungSelectVorbestellung,
      },
      {
        path: "reservierung-vorbestellung/:reservierungId",
        component: ReservierungVorbestellungNeu,
        children: [
          {
            path: "",
            name: RouteNames.RESERVIERUNG_VORBESTELLUNG.PRODUKTE,
            component: ReservierungVorbestellungProdukteNeu,
          },
          {
            path: "artikel/:id",
            name: RouteNames.NEU.RESERVIETUNG_VORBESTELLUNG.ARTIKEL,
            component: ReservierungVorbestellungArtikelNeu,
          },
          {
            path: "bestaetigen",
            name: RouteNames.NEU.RESERVIETUNG_VORBESTELLUNG.BESTAETIGEN,
            component: ReservierungVorbestellungBestaetigenNeu,
          },
          {
            path: "bearbeiten",
            name: RouteNames.RESERVIERUNG_VORBESTELLUNG.BEARBEITEN,
            component: ReservierungVorbestellungBearbeiten,
          },
        ],
      },
      {
        path: "bestaetigen",
        name: RouteNames.NEU.BESTAETIGEN,
        component: Bestaetigen,
      },
      {
        path: "bestaetigen-abholung",
        name: RouteNames.NEU.BESTAETIGEN_ABHOLUNG,
        component: BestaetigenAbholung2,
      },
      {
        path: "bestaetigen-lieferung",
        name: RouteNames.NEU.BESTAETIGEN_LIEFERUNG,
        component: BestaetigenLieferung,
      },
      {
        path: "bestaetigen-reservierung",
        name: RouteNames.NEU.BESTAETIGEN_RESERVIERUNG,
        component: BestaetigenReservierungNeu,
      },
      {
        path: "bezahlung-bestaetigen",
        name: RouteNames.NEU.BEZAHLUNG_BESTAETIGEN,
        component: BezahlungBestaetigen,
      },
      {
        path: "bestaetigt",
        name: RouteNames.NEU.BESTAETIGT,
        component: Bestaetigt,
      },
      {
        path: "reservierung-bestaetigt",
        name: RouteNames.NEU.RESERVIERUNG_BESTAETIGT,
        component: ReservierungBestaetigt,
      },
      {
        path: "bestellungen",
        name: RouteNames.BESTELLUNGEN,
        component: Bestellungen,
      },
      {
        path: "abgeschlossene-bestellungen",
        name: RouteNames.ABGESCHLOSSENE_BESTELLUNGEN,
        component: AbgeschlosseneBestellungen,
      },
      {
        path: "reservierung-details/:reservierungId",
        component: Reservierung,
        children: [
          {
            path: "",
            component: ReservierungDetails,
            name: RouteNames.RESERVIERUNG.DETAILS,
          },
          {
            path: "vorbestellung",
            component: ReservierungVorbestellung,
            children: [
              {
                path: "",
                name: RouteNames.RESERVIERUNG.VORBESTELLUNG_PRODUKTE,
                component: ReservierungVorbestellungProdukteNeu,
              },
              {
                path: "bestaetigen",
                name: RouteNames.RESERVIERUNG.VORBESTELLUNG_BESTAETIGEN,
                component: ReservierungVorbestellungBestaetigenNeu,
              },
            ],
          },
        ],
      },
      {
        path: "bestellung/:id",
        component: Bestellung,
        children: [
          {
            path: "",
            name: RouteNames.BESTELLUNG.DETAILS,
            component: Details,
          },
          {
            path: "reservierung-bestellung",
            component: ReservierungBestellung,
            children: [
              {
                path: "",
                name: RouteNames.BESTELLUNG.RESERVIERUNG_BESTELLUNG.PRODUKTE,
                component: ReservierungBestellungProdukte,
              },
              {
                path: "artikel/:id",
                name: RouteNames.BESTELLUNG.RESERVIERUNG_BESTELLUNG.ARTIKEL,
                component: ReservierungBestellungArtikel,
              },
              {
                path: "bestaetigen",
                name: RouteNames.BESTELLUNG.RESERVIERUNG_BESTELLUNG.BESTAETIGEN,
                component: ReservierungBestellungBestaetigen,
              },
            ],
          },
          {
            path: "service-anfordern",
            name: RouteNames.BESTELLUNG.SERVICE_ANFORDERN,
            meta: { transition: "slide-left" },
            component: ServiceAnfordern,
          },
          {
            path: "bezahlen",
            name: RouteNames.BESTELLUNG.BEZAHLEN,
            component: Bezahlen,
          },

          {
            path: "nachbestellen",
            component: Nachbestellung,
            children: [
              {
                path: "",
                name: RouteNames.BESTELLUNG.NACHBESTELLEN.PRODUKTE,
                component: NachbestellungProdukte,
              },
              {
                path: "artikel/:id",
                name: RouteNames.BESTELLUNG.NACHBESTELLEN.ARTIKEL,
                component: NachbestellungArtikel,
              },
              {
                path: "bestaetigen",
                name: RouteNames.BESTELLUNG.NACHBESTELLEN.BESTAETIGEN,
                component: NachbestellungBestaetigen,
              },
            ],
          },
          {
            path: "vorbestellung",
            component: ReservierungVorbestellung,
            children: [
              {
                path: "",
                name: RouteNames.BESTELLUNG.VORBESTELLUNG.PRODUKTE,
                component: ReservierungVorbestellungProdukte,
              },
              {
                path: "artikel/:id",
                name: RouteNames.BESTELLUNG.VORBESTELLUNG.ARTIKEL,
                component: ReservierungVorbestellungArtikel,
              },
              {
                path: "bestaetigen",
                name: RouteNames.BESTELLUNG.VORBESTELLUNG.BESTAETIGEN,
                component: ReservierungVorbestellungBestaetigen,
              },
            ],
          },
        ],
      },
      {
        path: "trinkgeld",
        name: RouteNames.NEU.TRINKGELD,
        component: Trinkgeld,
      },
      {
        path: "/bestellung-detail/:bestellungId",
        component: Bestellung,
        children: [
          {
            path: "",
            name: RouteNames.BESTELLUNG_PAGE.DETAILS,
            component: Details,
          },
          {
            path: "reservierung-bestellung",
            component: ReservierungBestellung,
            children: [
              {
                path: "",
                name: RouteNames.BESTELLUNG_PAGE.RESERVIERUNG.PRODUKTE,
                component: ReservierungBestellungProdukte,
              },
              {
                path: "artikel/:id",
                name: RouteNames.BESTELLUNG_PAGE.RESERVIERUNG.ARTIKEL,
                component: ReservierungBestellungArtikel,
              },
              {
                path: "bestaetigen",
                name: RouteNames.BESTELLUNG_PAGE.RESERVIERUNG.BESTAETIGEN,
                component: ReservierungBestellungBestaetigen,
              },
            ],
          },
          {
            path: "service-anfordern",
            name: RouteNames.BESTELLUNG_PAGE.SERVICE_ANFORDERN,
            meta: { transition: "slide-left" },
            component: ServiceAnfordern,
          },
          {
            path: "bezahlen",
            name: RouteNames.BESTELLUNG_PAGE.BEZAHLEN,
            component: Bezahlen,
          },
          {
            path: "trinkgeld",
            name: RouteNames.BESTELLUNG_PAGE.TRINKGELD,
            component: TrinkgeldBestellung,
          },
          {
            path: "nachbestellen",
            component: Nachbestellung,
            children: [
              {
                path: "",
                name: RouteNames.BESTELLUNG_PAGE.NACHBESTELLEN.PRODUKTE,
                component: NachbestellungProdukte,
              },
              {
                path: "artikel/:id",
                name: RouteNames.BESTELLUNG_PAGE.NACHBESTELLEN.ARTIKEL,
                component: NachbestellungArtikel,
              },
              {
                path: "bestaetigen",
                name: RouteNames.BESTELLUNG_PAGE.NACHBESTELLEN.BESTAETIGEN,
                component: NachbestellungBestaetigen,
              },
            ],
          },
          {
            path: "vorbestellung",
            component: ReservierungVorbestellung,
            children: [
              {
                path: "",
                name: RouteNames.BESTELLUNG_PAGE.VORBESTELLUNG.PRODUKTE,
                component: ReservierungVorbestellungProdukte,
              },
              {
                path: "artikel/:id",
                name: RouteNames.BESTELLUNG_PAGE.VORBESTELLUNG.ARTIKEL,
                component: ReservierungVorbestellungArtikel,
              },
              {
                path: "bestaetigen",
                name: RouteNames.BESTELLUNG_PAGE.VORBESTELLUNG.BESTAETIGEN,
                component: ReservierungVorbestellungBestaetigen,
              },
            ],
          },
        ],
      },
      {
        path: "/agb",
        name: RouteNames.AGB,
        component: AgbFiliale,
      },
      {
        path: "/datenschutz",
        name: RouteNames.DATENSCHUTZ,
        component: DatenschutzFiliale,
      },
      {
        path: "/impressum",
        name: RouteNames.IMPRESSUM,
        component: ImpressumFiliale,
      },
    ],
  },
  {
    path: "/bezahlen-bestaetigt/:bestellungId",
    name: RouteNames.BESTELLUNG.BEZAHLEN_BESTAETIGT,
    component: BezahlenBestaetigt,
  },
  {
    path: "/bezahlung-redirect/:bestellungId",
    name: RouteNames.NEU.BEZAHLUNG_WEITERLEITEN,
    component: BezahlungWeiterleiten,
  },
  {
    path: "/bezahlung-redirect-bestellung/:bestellungId",
    name: RouteNames.BESTELLUNG_PAGE.BEZAHLUNG_WEITERLEITEN,
    component: BezahlenWeiterleitenBestellung,
  },
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

router.beforeEach((to, from, next) => {
  next()
})

export default router
